import axios, {
  AxiosResponse,
  AxiosInstance,
  AxiosError,
  AxiosRequestConfig,
} from 'axios';
import { Config } from 'utils/config/config';
import { loadAuthToken } from 'utils/tokenStorage';
import { handleExpiredToken } from 'utils/session';
import {
  Configuration,
  DefaultApi as AuthClient,
} from '@peartherapeutics/auth-service-client';

export class AuthClientInstance {
  private static instance: AuthClient | null;

  public static get(): AuthClient {
    if (!this.instance) {
      const axiosInstanceInterceptors = this.setupInterceptors(axios.create());
      this.instance = new AuthClient(
        // potenially remove apiKey
        new Configuration({
          basePath: Config.AUTH_URL,
        }),
        undefined,
        axiosInstanceInterceptors,
      );
    }
    return this.instance;
  }

  private static onRequest(request: AxiosRequestConfig): AxiosRequestConfig {
    const loadToken = loadAuthToken();
    if (loadToken) {
      if (request?.headers) {
        request.headers.Authorization = `JWT ${loadToken}`;
      } else {
        request.headers = { Authorization: `JWT ${loadToken}` };
      }
    }
    return request;
  }

  private static onRequestError(error: AxiosError): Promise<AxiosError> {
    return Promise.reject(error);
  }

  private static onResponse(response: AxiosResponse): AxiosResponse {
    return response;
  }

  private static onResponseError(error: AxiosError): Promise<AxiosError> {
    if (
      error.response?.status === 401 &&
      !error?.request.responseURL.includes('/login')
    ) {
      handleExpiredToken();
    }
    return Promise.reject(error);
  }

  private static setupInterceptors(
    axiosInstance: AxiosInstance,
  ): AxiosInstance {
    axiosInstance.interceptors.request.use(this.onRequest, this.onRequestError);
    axiosInstance.interceptors.response.use(
      this.onResponse,
      this.onResponseError,
    );
    return axiosInstance;
  }

  public static reset(): void {
    this.instance = null;
  }
}
